import React from 'react';
import HubTabs from '../../components/syndication/HubTabs';
import SyndicationPayouts from './SyndicationPayouts';
import Commissions from '../Commissions';
import PartnerLedger from '../PartnerLedger';

// Payouts + ISO Commissions + Partner Ledger → one page. Old URLs redirect here with ?tab=.
export default function MoneyOut() {
  return (
    <HubTabs title="Money out" subtitle="Everything PFS pays: syndicators and referrers, ISO commissions, partner balances." testId="money-out"
             fallback="payouts"
             tabs={[
               { key: 'payouts', label: 'Syndicators & referrers', render: () => <SyndicationPayouts embedded /> },
               { key: 'isos', label: 'ISO commissions', render: () => <Commissions embedded /> },
               { key: 'partners', label: 'Partner ledger', render: () => <PartnerLedger embedded /> },
             ]} />
  );
}
